/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance } from 'mobx-state-tree';

const { model, boolean, string } = types;

export const NotificationStore = model('NotificationStore', {
  type: string,
  isOpen: boolean,
  message: string,
  direction: types.optional(types.string, 'default'),
  upgradeLiscenceCheck: types.optional(types.boolean, false),
})
  .views((self) => ({}))
  .volatile(() => ({}))
  .actions((self) => ({
    openNotification: (type: string, message: string, direction = 'default'): void => {
      self.type = type;
      self.isOpen = true;
      self.message = message;
      self.direction = direction;
    },
    setUpgradeNotification(value: boolean) {
      self.upgradeLiscenceCheck = value;
    },
    closeNotification: (): void => {
      self.isOpen = false;
      self.type = 'success';
      self.message = '';
      self.direction = 'default';
      self.upgradeLiscenceCheck = false;
    },
  }));

export type INotificationStore = Instance<typeof NotificationStore>;
